export default DeviceChecker

/** @ngInject */
function DeviceChecker() {
  // Currying
    const minWidth = (width) => () => window.innerWidth > width
    const maxWidth = (width) => () => window.innerWidth < width

    return {
        isMobile: maxWidth(768),
        isTab: maxWidth(992),
        isDesktop: maxWidth(1200),
        isLargeDesktop: minWidth(1200),
    }
}



// WEBPACK FOOTER //
// ./src/services/deviceChecker/device.checker.js